var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.677002 18.3019C0.677002 8.57453 8.56257 0.688965 18.2899 0.688965C28.0172 0.688965 35.9028 8.57453 35.9028 18.3019C35.9028 28.0292 28.0172 35.9148 18.2899 35.9148C8.56257 35.9148 0.677002 28.0292 0.677002 18.3019Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8359 10.7046C28.8425 10.9808 29.6352 11.7947 29.9042 12.8282C30.3931 14.7014 30.3931 18.6097 30.3931 18.6097C30.3931 18.6097 30.3931 22.5179 29.9042 24.3912C29.6352 25.4247 28.8425 26.2386 27.8359 26.5149C26.0117 27.0168 18.6963 27.0168 18.6963 27.0168C18.6963 27.0168 11.3809 27.0168 9.55659 26.5149C8.55 26.2386 7.75728 25.4247 7.48825 24.3912C6.99951 22.5179 6.99951 18.6097 6.99951 18.6097C6.99951 18.6097 6.99951 14.7014 7.48825 12.8282C7.75728 11.7947 8.55 10.9808 9.55659 10.7046C11.3809 10.2026 18.6963 10.2026 18.6963 10.2026C18.6963 10.2026 26.0117 10.2026 27.8359 10.7046ZM16.5032 15.3199V22.6304L22.3516 18.9753L16.5032 15.3199Z",
    fill: "#EC0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.addb5b9e5a90c764d46740c2895495f3.svg";
export { ForwardRef as ReactComponent };